module.exports = __webpack_public_path__ + "static/media/inf_41og42.0b291031.mp3";